import { motion } from 'framer-motion';
import { FC, ReactNode } from 'react';

type FadeInProps = {
  children: ReactNode;
  className?: string;
  delay?: number;
};

export const FadeIn: FC<FadeInProps> = ({ children, className, delay = 0 }) => (
  <motion.div
    animate={{ opacity: 1, y: 0 }}
    className={className}
    initial={{ opacity: 0, y: 8 }}
    transition={{ duration: 0.35, ease: 'easeOut', delay }}
  >
    {children}
  </motion.div>
);
